// extracted by mini-css-extract-plugin
export var audioPlayerWrapper = "styles-module--audioPlayerWrapper--eg0-j";
export var controlBar = "styles-module--control-bar--CpoFe";
export var controlButtons = "styles-module--control-buttons--yrmP3";
export var currentTrack = "styles-module--currentTrack--g-Qic";
export var playingIndicator = "styles-module--playingIndicator--D0lCH";
export var playlistContainer = "styles-module--playlistContainer--DbXqx";
export var playlistItem = "styles-module--playlistItem--5noH-";
export var trackInfo = "styles-module--trackInfo--EML63";
export var trackNumber = "styles-module--trackNumber--MUL4k";
export var trackTitle = "styles-module--trackTitle--U8ELz";